module.exports = __webpack_public_path__ + "img/selectIcon.0c420aef.png";